// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2R7-_","label":"CategoryService_label__2Cd5_","location":"CategoryService_location__2I0XT"};